// 北向资金：个股成交统计
export function share(title,url) {
	// let origin = location.href.split('#')[0];
	// url = origin + '#' +url;
	url = window.share_url;

	url = url.replace("DZHSPECIAL","DZH");
	if(typeof DzhAppJs != 'undefined') {
		if(DzhAppJs.hasOwnProperty('callAppWithChannelAndJsonAndCallbackFunc')){
			// DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('rtmenu','[{"label":"刷新","link":"dzh_browser_url&goto=0&screen=188"}]', null)
			DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('rtmenu','[{"label":"分享","link":"dzh_browser_url&goto=0&screen=143&title='+title+'&text=大智慧数据中心为您提供港股通数据，挖掘聪明资金动向&url='+url+'&icon=http://static.yundzh.com/logo.png&kind=55"}]', null)
		}
	}
}